// import produce from 'immer';

// const INITIAL_STATE = {
//   globParams: [],
//   sso: { quoteEmail: null, idioma: 'pt-BR' },
// };

// export default function param(state = INITIAL_STATE, action) {
//   return produce(state, (draft) => {
//     switch (action.type) {
//       case '@param/GLOB_PARAM_SUCCESS': {
//         draft.globParams = action.payload.params;
//         break;
//       }
//       case '@param/GLOB_PARAM_FAILURE': {
//         draft.globParams = [];
//         break;
//       }
//       case '@auth/SIGN_OUT': {
//         draft.globParams = [];
//         draft.sso = { quoteEmail: null, idioma: 'pt-BR' };
//         break;
//       }
//       case '@param/SSO_CONTEXT': {
//         draft.sso = action.payload;
//         break;
//       }
//       default:
//     }
//   });
// }

import produce from 'immer';

const INITIAL_STATE = {
  globParams: [],
  sso: { quoteEmail: null, idioma: 'pt-BR' },
  idiomaCatalogo: null,
};

export default function param(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@param/GLOB_PARAM_SUCCESS': {
        draft.globParams = action.payload.params;
        break;
      }
      case '@param/GLOB_PARAM_FAILURE': {
        draft.globParams = [];
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.globParams = [];
        draft.sso = { quoteEmail: null, idioma: 'pt-BR' };
        draft.idiomaCatalogo = null;
        break;
      }
      case '@param/SSO_CONTEXT': {
        draft.sso = action.payload;
        break;
      }
      case '@param/IDIOMA_CATALOGO': {
        draft.idiomaCatalogo = action.payload.idioma;
        break;
      }
      default:
    }
  });
}
